interface MenuItemAddition {
  path: string[]
  staticObj: any
  position?: number
}

export function addStaticMenuItems(menuData: any, staticMenuItems?: MenuItemAddition[]) {
  if (!staticMenuItems) {
    return menuData // Return the original data if staticMenuItems not given
  }

  let mutableMenuData = JSON.parse(JSON.stringify(menuData))

  staticMenuItems.forEach(({path, staticObj, position = 0, ...rest}) => {
    mutableMenuData = addMenuItem(mutableMenuData, path, staticObj, position, rest)
  })

  return mutableMenuData
}

function uuidv4() {
  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
    const r = (Math.random() * 16) | 0,
      v = c === 'x' ? r : (r && 0x3) || 0x8
    return v.toString(16)
  })
}

function addMenuItem(menuData: any, path: any, staticObj: any, position: number = 0, rest: any) {
  let mutableMenuData = JSON.parse(JSON.stringify(menuData))

  if (!path.length) {
    throw new Error('Path should not be empty')
  }

  const [current, ...remainingPath] = path

  // Create parent menu if it doesn't exist
  if (!mutableMenuData[current]) {
    mutableMenuData[current] = {
      id: rest.id || uuidv4(),
      label: rest.label || current.charAt(0).toUpperCase() + current.slice(1),
      route: rest.route || `/${current}`,
      api_path: rest.api_path || `/${current}`,
      icon: rest.icon || 'bi bi-folder',
      operation: rest.operation || {read: true, write: false},
      status: rest.status || 'active',
      created_at: rest.created_at || new Date().toISOString(),
      updated_at: new Date().toISOString(),
      children: {},
    }
  }

  if (remainingPath.length === 0) {
    mutableMenuData[current].children = mutableMenuData[current].children || {}

    const key = staticObj.label?.toLowerCase().replace(/ /g, '_')

    const completeStaticObj = {
      id: uuidv4(),
      created_at: new Date().toISOString(),
      updated_at: new Date().toISOString(),
      status: 'active',
      operation: {read: true, write: false},
      children: {},
      ...staticObj,
    }

    if (position !== 0) {
      const entries = Object.entries(mutableMenuData[current].children)
      entries.splice(position - 1, 0, [key, completeStaticObj])
      mutableMenuData[current].children = Object.fromEntries(entries)
    } else {
      mutableMenuData[current].children[key] = completeStaticObj
    }
  } else {
    mutableMenuData[current].children = addMenuItem(
      mutableMenuData[current].children,
      remainingPath,
      staticObj,
      position,
      rest
    )
  }

  return mutableMenuData
}
